import { isInAppWebView } from '@/lib/app-auth-bridge';
import { isLandingDocumentPath } from '@/lib/academy-visit';

/**
 * 학원 상세 하위 화면(리뷰 목록·수강료·셔틀·시험코스) 헤더 뒤로가기를 `back()` 대신 학원
 * 상세로 보낼지.
 *
 * 검색·공유 링크로 하위 화면에 바로 들어온 사람에게 `back()` 은 검색 결과로 나가거나(같은 탭)
 * 아무 일도 안 한다(새 탭). 그때는 학원 상세로 보낸다. 조건은 셋 다:
 * - 앱 웹뷰가 아니다 — 앱은 종전대로 `back()`(앱이 화면을 직접 여는 경우도 마찬가지).
 * - 이 문서가 처음 열린 화면 그대로다(`isLandingDocumentPath`).
 * - 리퍼러가 우리 사이트가 아니다 — `<a href>` 전체 이동으로 학원 상세에서 넘어오면 문서는
 *   새로 떴어도 돌아갈 곳이 있다.
 */
export function shouldBackToAcademyDetail({
  pathname,
  isApp,
}: {
  pathname: string | null;
  /** 호출부가 아는 앱 판정(`?hash`·회원 hash·앱 연결 여부) */
  isApp: boolean;
}): boolean {
  if (typeof window === 'undefined' || !pathname) return false;
  if (isApp || isInAppWebView()) return false;
  if (new URLSearchParams(window.location.search).get('isApp') === 'true') {
    return false;
  }
  if (!isLandingDocumentPath(pathname)) return false;
  try {
    if (
      document.referrer &&
      new URL(document.referrer).origin === window.location.origin
    ) {
      return false;
    }
  } catch {
    // 리퍼러를 못 읽으면 외부 유입으로 본다
  }
  return true;
}
